import type { PercentileCurvePoint } from './types'

// Source: WHO Child Growth Standards (2006)
// https://www.who.int/tools/child-growth-standards/standards/

export const headCircumferenceForAgeBoys: PercentileCurvePoint[] = [
  { month: 0, p3: 32.1, p15: 33.1, p50: 34.5, p85: 35.8, p97: 36.9 },
  { month: 1, p3: 35.1, p15: 36.1, p50: 37.3, p85: 38.5, p97: 39.5 },
  { month: 2, p3: 36.9, p15: 37.9, p50: 39.1, p85: 40.3, p97: 41.3 },
  { month: 3, p3: 38.3, p15: 39.3, p50: 40.5, p85: 41.7, p97: 42.7 },
  { month: 4, p3: 39.4, p15: 40.4, p50: 41.6, p85: 42.9, p97: 43.9 },
  { month: 5, p3: 40.3, p15: 41.3, p50: 42.6, p85: 43.8, p97: 44.8 },
  { month: 6, p3: 41, p15: 42.1, p50: 43.3, p85: 44.6, p97: 45.6 },
  { month: 7, p3: 41.7, p15: 42.7, p50: 44, p85: 45.3, p97: 46.3 },
  { month: 8, p3: 42.2, p15: 43.2, p50: 44.5, p85: 45.8, p97: 46.9 },
  { month: 9, p3: 42.6, p15: 43.7, p50: 45, p85: 46.3, p97: 47.4 },
  { month: 10, p3: 43, p15: 44.1, p50: 45.4, p85: 46.7, p97: 47.8 },
  { month: 11, p3: 43.4, p15: 44.4, p50: 45.8, p85: 47.1, p97: 48.2 },
  { month: 12, p3: 43.6, p15: 44.7, p50: 46.1, p85: 47.4, p97: 48.5 },
  { month: 13, p3: 43.9, p15: 45, p50: 46.3, p85: 47.7, p97: 48.8 },
  { month: 14, p3: 44.1, p15: 45.2, p50: 46.6, p85: 47.9, p97: 49 },
  { month: 15, p3: 44.3, p15: 45.5, p50: 46.8, p85: 48.2, p97: 49.3 },
  { month: 16, p3: 44.5, p15: 45.6, p50: 47, p85: 48.4, p97: 49.5 },
  { month: 17, p3: 44.7, p15: 45.8, p50: 47.2, p85: 48.6, p97: 49.7 },
  { month: 18, p3: 44.9, p15: 46, p50: 47.4, p85: 48.7, p97: 49.9 },
  { month: 19, p3: 45, p15: 46.2, p50: 47.5, p85: 48.9, p97: 50 },
  { month: 20, p3: 45.2, p15: 46.3, p50: 47.7, p85: 49.1, p97: 50.2 },
  { month: 21, p3: 45.3, p15: 46.4, p50: 47.8, p85: 49.2, p97: 50.4 },
  { month: 22, p3: 45.4, p15: 46.6, p50: 48, p85: 49.4, p97: 50.5 },
  { month: 23, p3: 45.6, p15: 46.7, p50: 48.1, p85: 49.5, p97: 50.7 },
  { month: 24, p3: 45.7, p15: 46.8, p50: 48.3, p85: 49.7, p97: 50.8 },
  { month: 25, p3: 45.8, p15: 47, p50: 48.4, p85: 49.8, p97: 50.9 },
  { month: 26, p3: 45.9, p15: 47.1, p50: 48.5, p85: 49.9, p97: 51.1 },
  { month: 27, p3: 46, p15: 47.2, p50: 48.6, p85: 50, p97: 51.2 },
  { month: 28, p3: 46.1, p15: 47.3, p50: 48.7, p85: 50.2, p97: 51.3 },
  { month: 29, p3: 46.2, p15: 47.4, p50: 48.8, p85: 50.3, p97: 51.4 },
  { month: 30, p3: 46.3, p15: 47.5, p50: 48.9, p85: 50.4, p97: 51.6 },
  { month: 31, p3: 46.4, p15: 47.6, p50: 49, p85: 50.5, p97: 51.7 },
  { month: 32, p3: 46.5, p15: 47.7, p50: 49.1, p85: 50.6, p97: 51.8 },
  { month: 33, p3: 46.6, p15: 47.8, p50: 49.2, p85: 50.7, p97: 51.9 },
  { month: 34, p3: 46.6, p15: 47.8, p50: 49.3, p85: 50.8, p97: 52 },
  { month: 35, p3: 46.7, p15: 47.9, p50: 49.4, p85: 50.8, p97: 52 },
  { month: 36, p3: 46.8, p15: 48, p50: 49.5, p85: 50.9, p97: 52.1 },
  { month: 37, p3: 46.9, p15: 48.1, p50: 49.5, p85: 51, p97: 52.2 },
  { month: 38, p3: 46.9, p15: 48.1, p50: 49.6, p85: 51.1, p97: 52.3 },
  { month: 39, p3: 47, p15: 48.2, p50: 49.7, p85: 51.2, p97: 52.4 },
  { month: 40, p3: 47, p15: 48.3, p50: 49.7, p85: 51.2, p97: 52.4 },
  { month: 41, p3: 47.1, p15: 48.3, p50: 49.8, p85: 51.3, p97: 52.5 },
  { month: 42, p3: 47.2, p15: 48.4, p50: 49.9, p85: 51.4, p97: 52.6 },
  { month: 43, p3: 47.2, p15: 48.4, p50: 49.9, p85: 51.4, p97: 52.7 },
  { month: 44, p3: 47.3, p15: 48.5, p50: 50, p85: 51.5, p97: 52.7 },
  { month: 45, p3: 47.3, p15: 48.5, p50: 50.1, p85: 51.6, p97: 52.8 },
  { month: 46, p3: 47.4, p15: 48.6, p50: 50.1, p85: 51.6, p97: 52.8 },
  { month: 47, p3: 47.4, p15: 48.6, p50: 50.2, p85: 51.7, p97: 52.9 },
  { month: 48, p3: 47.5, p15: 48.7, p50: 50.2, p85: 51.7, p97: 53 },
  { month: 49, p3: 47.5, p15: 48.7, p50: 50.3, p85: 51.8, p97: 53 },
  { month: 50, p3: 47.5, p15: 48.8, p50: 50.3, p85: 51.8, p97: 53.1 },
  { month: 51, p3: 47.6, p15: 48.8, p50: 50.4, p85: 51.9, p97: 53.1 },
  { month: 52, p3: 47.6, p15: 48.9, p50: 50.4, p85: 51.9, p97: 53.2 },
  { month: 53, p3: 47.7, p15: 48.9, p50: 50.4, p85: 52, p97: 53.2 },
  { month: 54, p3: 47.7, p15: 49, p50: 50.5, p85: 52, p97: 53.3 },
  { month: 55, p3: 47.7, p15: 49, p50: 50.5, p85: 52.1, p97: 53.3 },
  { month: 56, p3: 47.8, p15: 49, p50: 50.6, p85: 52.1, p97: 53.4 },
  { month: 57, p3: 47.8, p15: 49.1, p50: 50.6, p85: 52.2, p97: 53.4 },
  { month: 58, p3: 47.9, p15: 49.1, p50: 50.7, p85: 52.2, p97: 53.5 },
  { month: 59, p3: 47.9, p15: 49.2, p50: 50.7, p85: 52.2, p97: 53.5 },
  { month: 60, p3: 47.9, p15: 49.2, p50: 50.7, p85: 52.3, p97: 53.5 }
]

export const headCircumferenceForAgeGirls: PercentileCurvePoint[] = [
  { month: 0, p3: 31.7, p15: 32.7, p50: 33.9, p85: 35.1, p97: 36.1 },
  { month: 1, p3: 34.3, p15: 35.3, p50: 36.5, p85: 37.8, p97: 38.8 },
  { month: 2, p3: 36, p15: 37, p50: 38.3, p85: 39.5, p97: 40.5 },
  { month: 3, p3: 37.2, p15: 38.2, p50: 39.5, p85: 40.8, p97: 41.9 },
  { month: 4, p3: 38.2, p15: 39.3, p50: 40.6, p85: 41.9, p97: 43 },
  { month: 5, p3: 39, p15: 40.1, p50: 41.5, p85: 42.8, p97: 43.9 },
  { month: 6, p3: 39.7, p15: 40.8, p50: 42.2, p85: 43.5, p97: 44.6 },
  { month: 7, p3: 40.4, p15: 41.5, p50: 42.8, p85: 44.2, p97: 45.3 },
  { month: 8, p3: 40.9, p15: 42, p50: 43.4, p85: 44.7, p97: 45.9 },
  { month: 9, p3: 41.3, p15: 42.4, p50: 43.8, p85: 45.2, p97: 46.3 },
  { month: 10, p3: 41.7, p15: 42.8, p50: 44.2, p85: 45.6, p97: 46.8 },
  { month: 11, p3: 42, p15: 43.2, p50: 44.6, p85: 46, p97: 47.1 },
  { month: 12, p3: 42.3, p15: 43.5, p50: 44.9, p85: 46.3, p97: 47.5 },
  { month: 13, p3: 42.6, p15: 43.8, p50: 45.2, p85: 46.6, p97: 47.7 },
  { month: 14, p3: 42.9, p15: 44, p50: 45.4, p85: 46.8, p97: 48 },
  { month: 15, p3: 43.1, p15: 44.2, p50: 45.7, p85: 47.1, p97: 48.2 },
  { month: 16, p3: 43.3, p15: 44.4, p50: 45.9, p85: 47.3, p97: 48.5 },
  { month: 17, p3: 43.5, p15: 44.6, p50: 46.1, p85: 47.5, p97: 48.7 },
  { month: 18, p3: 43.6, p15: 44.8, p50: 46.2, p85: 47.7, p97: 48.8 },
  { month: 19, p3: 43.8, p15: 45, p50: 46.4, p85: 47.8, p97: 49 },
  { month: 20, p3: 44, p15: 45.1, p50: 46.6, p85: 48, p97: 49.2 },
  { month: 21, p3: 44.1, p15: 45.3, p50: 46.7, p85: 48.2, p97: 49.4 },
  { month: 22, p3: 44.3, p15: 45.4, p50: 46.9, p85: 48.3, p97: 49.5 },
  { month: 23, p3: 44.4, p15: 45.6, p50: 47, p85: 48.5, p97: 49.7 },
  { month: 24, p3: 44.6, p15: 45.7, p50: 47.2, p85: 48.6, p97: 49.8 },
  { month: 25, p3: 44.7, p15: 45.9, p50: 47.3, p85: 48.8, p97: 49.9 },
  { month: 26, p3: 44.8, p15: 46, p50: 47.5, p85: 48.9, p97: 50.1 },
  { month: 27, p3: 44.9, p15: 46.1, p50: 47.6, p85: 49, p97: 50.2 },
  { month: 28, p3: 45.1, p15: 46.3, p50: 47.7, p85: 49.2, p97: 50.3 },
  { month: 29, p3: 45.2, p15: 46.4, p50: 47.8, p85: 49.3, p97: 50.5 },
  { month: 30, p3: 45.3, p15: 46.5, p50: 47.9, p85: 49.4, p97: 50.6 },
  { month: 31, p3: 45.4, p15: 46.6, p50: 48, p85: 49.5, p97: 50.7 },
  { month: 32, p3: 45.5, p15: 46.7, p50: 48.1, p85: 49.6, p97: 50.8 },
  { month: 33, p3: 45.6, p15: 46.8, p50: 48.2, p85: 49.7, p97: 50.9 },
  { month: 34, p3: 45.7, p15: 46.9, p50: 48.3, p85: 49.8, p97: 51 },
  { month: 35, p3: 45.8, p15: 47, p50: 48.4, p85: 49.9, p97: 51.1 },
  { month: 36, p3: 45.9, p15: 47, p50: 48.5, p85: 50, p97: 51.2 },
  { month: 37, p3: 45.9, p15: 47.1, p50: 48.6, p85: 50.1, p97: 51.3 },
  { month: 38, p3: 46, p15: 47.2, p50: 48.7, p85: 50.1, p97: 51.3 },
  { month: 39, p3: 46.1, p15: 47.3, p50: 48.7, p85: 50.2, p97: 51.4 },
  { month: 40, p3: 46.2, p15: 47.4, p50: 48.8, p85: 50.3, p97: 51.5 },
  { month: 41, p3: 46.2, p15: 47.4, p50: 48.9, p85: 50.4, p97: 51.6 },
  { month: 42, p3: 46.3, p15: 47.5, p50: 49, p85: 50.4, p97: 51.6 },
  { month: 43, p3: 46.4, p15: 47.6, p50: 49, p85: 50.5, p97: 51.7 },
  { month: 44, p3: 46.4, p15: 47.6, p50: 49.1, p85: 50.6, p97: 51.8 },
  { month: 45, p3: 46.5, p15: 47.7, p50: 49.2, p85: 50.6, p97: 51.8 },
  { month: 46, p3: 46.5, p15: 47.7, p50: 49.2, p85: 50.7, p97: 51.9 },
  { month: 47, p3: 46.6, p15: 47.8, p50: 49.3, p85: 50.7, p97: 51.9 },
  { month: 48, p3: 46.7, p15: 47.9, p50: 49.3, p85: 50.8, p97: 52 },
  { month: 49, p3: 46.7, p15: 47.9, p50: 49.4, p85: 50.9, p97: 52.1 },
  { month: 50, p3: 46.8, p15: 48, p50: 49.4, p85: 50.9, p97: 52.1 },
  { month: 51, p3: 46.8, p15: 48, p50: 49.5, p85: 51, p97: 52.2 },
  { month: 52, p3: 46.9, p15: 48.1, p50: 49.5, p85: 51, p97: 52.2 },
  { month: 53, p3: 46.9, p15: 48.1, p50: 49.6, p85: 51.1, p97: 52.3 },
  { month: 54, p3: 47, p15: 48.2, p50: 49.6, p85: 51.1, p97: 52.3 },
  { month: 55, p3: 47, p15: 48.2, p50: 49.7, p85: 51.2, p97: 52.4 },
  { month: 56, p3: 47.1, p15: 48.3, p50: 49.7, p85: 51.2, p97: 52.4 },
  { month: 57, p3: 47.1, p15: 48.3, p50: 49.8, p85: 51.3, p97: 52.5 },
  { month: 58, p3: 47.2, p15: 48.4, p50: 49.8, p85: 51.3, p97: 52.5 },
  { month: 59, p3: 47.2, p15: 48.4, p50: 49.9, p85: 51.4, p97: 52.6 },
  { month: 60, p3: 47.2, p15: 48.4, p50: 49.9, p85: 51.4, p97: 52.6 }
]
